// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';

export async function getRoutes() {
  const routes = {"1":{"path":"/landing","layout":false,"id":"1"},"2":{"path":"/user","layout":false,"id":"2"},"3":{"name":"登录","path":"/user/login","parentId":"2","id":"3"},"4":{"path":"/welcome","name":"欢迎","icon":"smile","parentId":"ant-design-pro-layout","id":"4"},"5":{"name":"产品管理","icon":"appstore","path":"/product-manage","parentId":"ant-design-pro-layout","id":"5"},"6":{"name":"用户管理","icon":"team","path":"/user-manage","parentId":"ant-design-pro-layout","id":"6"},"7":{"path":"/","redirect":"/landing","parentId":"ant-design-pro-layout","id":"7"},"8":{"path":"/admin","redirect":"/welcome","parentId":"ant-design-pro-layout","id":"8"},"9":{"path":"*","layout":false,"id":"9"},"ant-design-pro-layout":{"id":"ant-design-pro-layout","path":"/","isLayout":true}} as const;
  return {
    routes,
    routeComponents: {
'1': React.lazy(() => import(/* webpackChunkName: "p__landing__index" */'@/pages/landing/index.tsx')),
'2': React.lazy(() => import('./EmptyRoute')),
'3': React.lazy(() => import(/* webpackChunkName: "p__user__login__index" */'@/pages/user/login/index.tsx')),
'4': React.lazy(() => import(/* webpackChunkName: "p__Welcome" */'@/pages/Welcome.tsx')),
'5': React.lazy(() => import(/* webpackChunkName: "p__product-table__index" */'@/pages/product-table/index.tsx')),
'6': React.lazy(() => import(/* webpackChunkName: "p__user-table__index" */'@/pages/user-table/index.tsx')),
'7': React.lazy(() => import('./EmptyRoute')),
'8': React.lazy(() => import('./EmptyRoute')),
'9': React.lazy(() => import(/* webpackChunkName: "p__404" */'@/pages/404.tsx')),
'ant-design-pro-layout': React.lazy(() => import(/* webpackChunkName: "t__plugin-layout__Layout" */'/Users/nlwy/Documents/workspace/web-scoutech/src/.umi-production/plugin-layout/Layout.tsx')),
},
  };
}
